import {urlPrefixed} from '@wandb/common/config';
import {TargetBlank} from '@wandb/common/util/links';
import React from 'react';

import {isInIframe} from '../setup';
import {useViewer} from '../state/viewer/hooks';
import {login, signup} from '../util/urls';

interface NewUserFooterProps {
  whatFor?: string;
  skipMadeWith?: boolean;
}

const NewUserFooter: React.FC<NewUserFooterProps> = (
  props: NewUserFooterProps
) => {
  const viewer = useViewer();
  if (viewer) {
    return <></>;
  }
  const madeWith = props.skipMadeWith ? '' : 'Made with Weights & Biases.';
  return (
    <div className="new-user-footer">
      <div className="divider" />
      <div className="cta">
        {madeWith}{' '}
        <TargetBlank
          href={urlPrefixed(signup())}
          target={isInIframe() ? '_blank' : '_self'}
          className="footer-link"
          data-test="signup">
          Sign up
        </TargetBlank>{' '}
        or{' '}
        <TargetBlank
          href={login()}
          target={isInIframe() ? '_blank' : '_self'}
          className="footer-link">
          log in
        </TargetBlank>{' '}
        {props.whatFor}
      </div>
    </div>
  );
};

export default NewUserFooter;
